import { Injectable } from '@angular/core';
import * as SentryAngular from '@sentry/angular';
import { omit } from 'lodash';
import { BackendService } from './backend.service';
import { Settings } from './models';

@Injectable({ providedIn: 'root' })
export class SettingsDataService {
  settings: Settings | null = null;
  private ready: Promise<boolean> | null = null;
  private isLoading = false;

  constructor(private readonly backendService: BackendService) {
  }

  loaded(): Promise<boolean> {
    if (!this.ready || (!this.settings && !this.isLoading)) {
      this.isLoading = true;
      this.ready = this.loadSettings().catch(() => false).finally(() => {
        this.isLoading = false;
      });
    }

    return this.ready;
  }

  private async loadSettings(): Promise<boolean> {
    this.settings = await this.backendService.fetchSettings();
    SentryAngular.setExtra('settings', JSON.stringify(omit(this.settings, 'users', 'collections', 'brand')));
    return true;
  }
}
